if (!customElements.get('quick-comparison-table')) {
  customElements.define(
    'quick-comparison-table',
    class QuickComparisonTable extends HTMLElement {
      constructor() {
        super();

        if ('requestIdleCallback' in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '0px 0px 400px 0px' });
        }
      }

      init() {
        const url = this.dataset.url;
        fetch(url)
          .then((response) => {
            if (!response.ok) {
              throw new Error(`Quick comparison table request failed: ${response.status}`);
            }
            return response.text();
          })
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, 'text/html')
              .querySelector('.shopify-section');
      
            if (!sectionInnerHTML) { return; }
      
            const recommendations = sectionInnerHTML.querySelector('quick-comparison-table');
      
            // No comparison table returned
            if (!recommendations) {
              this.closest('.shopify-section')?.remove();
              this.dispatchEvent(new CustomEvent('quick-comparison-table:empty'));
              return;
            }
      
            // Copy comparison table content
            if (recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
      
            const comparisonContainer = recommendations.querySelector(
              '.quick-comparison-table-container'
            );
      
            if (comparisonContainer) {
              this.dispatchEvent(new CustomEvent('quick-comparison-table:loaded'));
            } else {
              this.closest('.shopify-section')?.remove();
              this.dispatchEvent(new CustomEvent('quick-comparison-table:empty'));
            }
          })
          .catch((error) => {
            console.error('Quick comparison table error:', error);
          });
      }
    }
  );
}
